



























































































































import IListDock from '@/store/models/IListDock';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListDocksSelector extends Vue {
    searchListDocks: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListDock = {
        id: "",
        name: "",
        idCompany: "",
        idWarehouse: ""
    }
    defaultItem : IListDock = {
        id: "",
        name: "",
        idCompany: "",
        idWarehouse: ""
    }

    @Prop({ type: Array, required: true })
    ListDocksList !: IListDock[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListDocks : IListDock[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Dock' : 'Edit Dock'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListDocks() {
        this.selectedListDocks = [];
    }

    editListDock (item: any, dbox = true) {
        this.editedIndex = this.ListDocksList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListDock () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListDocks[0]) {
                this.close();
                this.$emit('editListDock', this.editedItem);
                Object.assign(this.ListDocksList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListDocks[0] = this.editedItem;
                this.$emit('saveListDock', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListDock (dock: IListDock) {
        this.$emit('deleteListDock', dock);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListDocks(item : any) : void {
        if (!this.selectedListDocks.includes(item)) {
            this.selectedListDocks = [];
            this.selectedListDocks = [item];
        } else {
            this.selectedListDocks = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
